import StatusWorkOrderList from '@/components/Settings/Profiles/StatusWorkOrder/StatusWorkOrderList';
import StatusWorkOrderModal from '@/components/Settings/Profiles/StatusWorkOrder/StatusWorkOrderModal';
import { useDisclosure } from '@/hooks';
import Authorities from '@/types/Authority';
import { PageProps } from '@/types/PageProps';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Typography } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function StatusWorkOrderPage({ route }: PageProps) {
  const intl = useIntl();
  const { Title, Paragraph } = Typography;

  const [modalOpened, modalActions] = useDisclosure();

  const hasCreateStatusPermission = hasPermissions([
    Authorities.YARDMANAGEMENT_FOLLOWUP_CREATE_STATUS,
  ]);

  return (
    <>
      <div className="page">
        <Helmet title={intl.formatMessage({ id: route.name })} />
        <div className="page-header">
          <Title level={4}>{intl.formatMessage({ id: route.name })}</Title>

          <Button
            type="primary"
            onClick={modalActions.open}
            disabled={!hasCreateStatusPermission}
          >
            Criar Status
          </Button>
        </div>

        <Paragraph style={{ marginTop: '16px' }}>
          Crie status customizados, para identificação dos veículos no pátio da
          sua oficina, vinculando-os as ordens de serviços
        </Paragraph>

        <StatusWorkOrderList />
      </div>

      <StatusWorkOrderModal open={modalOpened} onCancel={modalActions.close} />
    </>
  );
}
